export const FB_PAGES_DATA = 'getFBPagesData';
export const SELECT_AGENT_NAME_FOR_FB_PAGE = 'selectAgentNameForFBPage';
export const DELETE_FB_PAGE = 'deleteFBPage';
